//todo: refactorizar.
export const urlBucketBalance = (bucketUrl, pathImage, height = "", width = "", extension = "png") => {
    let id = "";
    let ext = "";
    if (pathImage.toString().indexOf("fotos") !== -1) {
        const startIndex = pathImage.indexOf("fotos") + 9; // (fotos/23/) = 9
        const finalIndex = pathImage.length - 4;
        id = pathImage.substr(startIndex, finalIndex - startIndex);
        ext = pathImage.substr(pathImage.length - 3);
    } else {
        id = pathImage.toString();
        ext = extension;
    }
    let bucketSrv = "1";
    height = (height === "") ? "" : `h${height}`;
    width = (width === "") ? "" : `w${width}`;
    const ultdos = id.substr(id.length - 2);
    const ultdig = ultdos.substr(ultdos.length - 1);
    switch (ultdig)
    {
        case "0":
        case "1":
        case "2":
            bucketSrv = "1";
            break;
        case "3":
        case "4":
        case "5":
            bucketSrv = "2";
            break;
        default:
            bucketSrv = "3";
            break;
    }
    
    var url = `${bucketUrl.replace("{nro}", bucketSrv)}/anexos/fotos/${ultdos}/${id}${width}${height}.${ext}`;

    return url;
}

export const urlBucketClubLn = (bucketUrl, pathImage, height = "", width = "", extension = "png") => {
    let id = "";
    let ext = "";
    if (pathImage.toString().indexOf("fotos") !== -1) {
        const startIndex = pathImage.indexOf("fotos") + 9; // (fotos/23/) = 9
        const finalIndex = pathImage.length - 4;
        id = pathImage.substr(startIndex, finalIndex - startIndex);
        ext = pathImage.substr(pathImage.length - 3);
    } else {
        id = pathImage.toString();
        ext = extension;
    }
    
    height = (height === "") ? "" : `h${height}`;
    width = (width === "") ? "" : `w${width}`;
    const ultdos = id.substr(id.length - 2);

    var url = `${bucketUrl}/${ultdos}/I${id}${width}${height}.${ext}`;

    return url;
}

// type, classSize
export const getImageSrcPath = (img, type, classSize) => {
    const classFinal = classSize.substr(0, 2).trim();
    let height = "";

    //Se define la resolución depende del tipo(img, galeria, etc..) y class(L, XL).
    (type === "galeria") 
        ? (classFinal === "L") //si no es L..  es XL
        ?  height = "484"
        : height = "688"
        : (type === "imagen") 
        ? (classFinal === "L") //si no es L..  es XL 
        ?  height = "640"
        : height = "540"
        : (type === "Encolumnada") 
        ? height = "280" 
        : (type === "modal") 
        ? height = "765" : "";
   
    //const carpeta = "\\anexos\\fotos\\" + img.id.toString().slice(-2);
    return height;
}


export const changeSizeWithFullPath = (srcImage, size) => {
    (srcImage.substr(srcImage.length - 1) === "/") ? srcImage = srcImage.slice(0, -1) : "";
    const startIndex = srcImage.indexOf("fotos/") + 9;
    const finalIndex = srcImage.length - 4;

    const ext = srcImage.substr(srcImage.length - 3);
    const bucketUrl = srcImage.substr(0, startIndex);
    const imageWithSize = srcImage.substr(startIndex, finalIndex - startIndex);
    const imageHeight = imageWithSize.indexOf("h");
    const imageWidth = imageWithSize.indexOf("w");

    let imageFinal = "";
    (imageHeight > imageWidth)
        ? imageFinal = imageWithSize.slice(0, imageHeight)
        : imageFinal = imageWithSize.slice(0, imageWidth);

    return `${bucketUrl}${imageFinal}${size}.${ext}`;
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/bucket.js